import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Divider, Paper, Stack, Typography, useTheme, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormInputText } from '../../../form-components/FormInputText';
import { useForm } from 'react-hook-form';
import { sendVerification, findUserName } from '../../../api/verification';
import { useToast } from 'use-toast-mui';
import { errorMessages } from '../../../utils/methods';

const ForgotTab1 = ({ setData, setNext }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const toast = useToast();
  const [isEmailRecieved, setIsEmailRecieved] = useState(false);

  const {
    control,
    handleSubmit,
    setError,
    getValues,
    register,
    watch,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      verificationCode: '',
      email: '',
    },
  });

  // Sending verification code function
  const sendVerifyCode = async () => {
    const email = watch('email');
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    // Check if email is valid
    if (!email) {
      return setError('email', {
        type: 'manual',
        message: '이메일을 입력해주세요',
      });
    } else {
      if (regex.test(email)) {
        clearErrors('email');
      } else {
        return setError('email', {
          type: 'manual',
          message: '이메일이 올바르지 않습니다',
        });
      }
    }

    try {
      // Send verification email
      const response = await sendVerification({ email });
      setIsEmailRecieved(true);
      toast.success('인증번호 발송되었습니다');
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  useEffect(() => {
    if (isEmailRecieved && watch('verificationCode')) {
      setData({ email: watch('email'), verificationCode: watch('verificationCode') });
      setNext(false);
    } else {
      setNext(true);
    }
  }, [watch('verificationCode')]);

  return (
    <Box sx={{ display: 'flex', mt: 4 }}>
      <Box sx={{ m: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '670px',
            maxHeight: '160px',
            background: '#F5F5F5',
            padding: '60px 120px',
            borderRadius: '16px',
            color: '#111111',
          }}>
          <Stack ml="6px">
            <Typography sx={{ fontWeight: 'bold', fontSize: '17px', textAlign: 'center', mb: '5px' }}>
              기업 회원 가입 시 등록한 이메일 주소를 입력해 주세요.
            </Typography>
            <Typography sx={{ fontWeight: 'bold', fontSize: '17px', textAlign: 'center', mb: '5px' }}>
              해당 이메일로 인증 번호를 전송합니다.
            </Typography>
            {/*<Typography sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', color: '#707070' }}>*/}
            {/*  * 임직원은 중복 메일이 가능하기 때문에 기업회원만 가능합니다.*/}
            {/*</Typography>*/}
          </Stack>
        </Box>

        <Grid container sx={{ justifyContent: 'space-between', maxWidth: '484px', margin: 'auto', height: '140px' }}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>이메일</Typography>
              </Grid>
              <Grid item xs={8}>
                <FormInputText
                  sx={{ maxHeight: '40px' }}
                  className="input-large"
                  name="email"
                  setValue={setValue}
                  control={control}
                  placeholder="이메일을 입력해 주세요"
                  error={!!errors.email}
                  helperText={errors?.email?.message}
                  // {...register('email', {
                  //   required: '이메일을 입력해주세요',
                  //   pattern: {
                  //     value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, // Email pattern validation
                  //     message: '유효한 이메일 주소를 입력해주세요',
                  //   },
                  // })}
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  onClick={sendVerifyCode}
                  variant="contained"
                  color="primary"
                  sx={{
                    height: 40,
                    bgcolor: '#F8FBFB',
                    boxShadow: 'none',
                    color: '#0F7F85',
                    fontSize: '13px',
                    fontWeight: 500,
                    lineHeight: '15.51px',
                    ml: 1,
                    '&:hover': { color: '#fff' },
                  }}>
                  전송
                </Button>
              </Grid>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', mt: 3.25 }}>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>인증번호입력</Typography>
              </Grid>
              <Grid item xs={10}>
                <FormInputText
                  className="input-large"
                  name="verificationCode"
                  control={control}
                  setValue={setValue}
                  placeholder="인증번호를 입력해 주세요"
                />
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ForgotTab1;
